import { getUniqIds } from '@utils/getUniqIds';

export function getUniqSortedIds(ids: (string | undefined)[]): string[] {
    return getUniqIds(ids).sort();
}
